import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  /* POPUP CONTAINER */
  popup: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1300,
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.3)",
    padding: "20px 0",
  },

  /* MAIN HOLDER */
  holder: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 40,

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: 24,
    },
  },

  /* LEFT TEXT BLOCK */
  holderInfo: {
    maxWidth: 520,
  },

  textBlock: {
    fontSize: 14,
    lineHeight: "22px",
    marginBottom: 6,
    color: theme.palette.text.primary,
  },

  moreLink: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.primary.main,
    textDecoration: "none",

    "&:hover": {
      textDecoration: "underline",
    },
  },

  /* RIGHT SIDE */
  holderCookies: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: 640,
  },

  /* CHECKBOXES ROW */
  cookiesRow: {
    display: "flex",
    gap: 40,

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: 16,
    },
  },

  cookiesBlock: {
    maxWidth: 300,
  },

  checkboxTitle: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
  },

  cookiesDescription: {
    fontSize: 13,
    lineHeight: "18px",
    // marginLeft: 32, // aligns text under MUI checkbox
    marginTop: 4,
    color: theme.palette.text.secondary,
  },

  /* BUTTONS */
  btnHolder: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 24,
    marginTop: 18,

    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-between",
    },
  },

  linkBtn: {
    minWidth: "unset",
    // padding: 0,
    textTransform: "uppercase",
    fontSize: 16,
    color: "#4646b4",
    padding: "20px",
    justifyContent: "flex-end",

    "& .MuiButton-label": {
      fontWeight: 700,
    },

    "&:hover": {
      backgroundColor: "transparent",
      // textDecoration: "underline",
      opacity: 0.8,
    },

    "&:focus-visible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
}));
